import { Button } from "@workspace/web-ui/components/button";
import { Separator } from "@workspace/web-ui/components/separator";
import { PenLine, Plus } from "lucide-react";
import { Allergy } from "~/features/dashboard/pages/medicals/types";
import { Modal } from "~/features/dashboard/components/modal";
import { AllergyForm } from "./forms/allergy-form";
import { useUpdateAllergyModal } from "~/features/dashboard/pages/medicals/store/allergy-modal";
import { useState } from "react";
import { Badge } from "@workspace/web-ui/components/badge";

const severityColors: Record<string, string> = {
  Severe: "bg-[#E12121]",
  Moderate: "bg-[#FFAB1F]",
  Mild: "bg-[#019939]",
};

interface AllergiesCardProps {
  items: Allergy[];
  onButtonClick?: () => void;
  totalCount?: number;
}

// const mockAllergyData = [
//   {
//     allergy_id: "1",
//     user_id: "1",
//     created_at: "2021-01-01",
//     name: "Penicillin",
//     severity: "Severe",
//     symptoms: "Hives, difficulty breathing, swelling of face and throat"
//   },
//   {
//     allergy_id: "2",
//     user_id: "1",
//     created_at: "2021-01-01",
//     name: "Peanuts",
//     severity: "Moderate",
//     symptoms: "Skin rash, nausea, vomiting, stomach cramps"
//   },
//   {
//     allergy_id: "3",
//     user_id: "1",
//     created_at: "2021-01-01",
//     name: "Shellfish",
//     severity: "Severe",
//     symptoms: "Anaphylaxis, swelling, difficulty swallowing, dizziness"
//   },
//   {
//     allergy_id: "4",
//     user_id: "1",
//     created_at: "2021-01-01",
//     name: "Latex",
//     severity: "Mild",
//     symptoms: "Contact dermatitis, itching, redness"
//   },

// ];

export function AllergiesCard({ items, onButtonClick, totalCount }: AllergiesCardProps) {
  const [selectedAllergy, setSelectedAllergy] = useState<Allergy | null>(null);
  const { isOpen: isAllergyModalOpen, open: openAllergyModal, close: closeAllergyModal } = useUpdateAllergyModal()

  console.log("items", items)

  return (
    <div className="border rounded-xl mt-0 shadow-sm bg-white w-full text-center">
      <header className="flex items-center justify-between p-5">
        <h3 className="text-lg font-medium text-[#1A202C]">Allergies <Badge className="ml-2 size-4 rounded-full bg-[#4272DD] border border-[#0404041A] p-2 justify-center items-center text-center text-white text-xs">
          {totalCount || 0}
        </Badge></h3>
        {onButtonClick && (
          <Button
            variant="outline"
            className="px-[14px] py-[12px] w-[80px] h-[40px] rounded-[10px] text-[#202020CC]"
            onClick={onButtonClick}
          >
            <Plus size={16} />
            Add
          </Button>
        )}
      </header>
      <Separator />
      <div className="space-y-4 p-5">
        <ul className="space-y-4">
          {items.map((allergy, index) => (
            <>
              <li
                key={index}
                className="px-5 py-3 border-l-[4px] items-start justify-between border-[#6E23C9] gap-4 shadow-sm flex bg-[#6E23C90D]"
              >
                <div className="flex flex-col text-left space-y-1">
                  <div className="flex items-center gap-2">
                    <span className={`size-3 rounded-full ${severityColors[allergy.severity]}`} />
                    <h3 className="font-medium text-base">{allergy.name}</h3>
                  </div>
                  <p className="text-sm">Severity: <span className="font-medium">{allergy.severity}</span></p>
                  <p className="text-sm">Symptoms: <span className="font-medium">{allergy.symptoms}</span></p>
                </div>

                <Button
                  onClick={() => { setSelectedAllergy(allergy); openAllergyModal() }}
                  variant="ghost"
                  size="sm"
                  className="gap-1 bg-white hover:bg-gray-100 border py-[10px] border-[#DCDCDE] rounded-lg text-sm flex items-center self-start justify-center"
                >
                  <PenLine size={10} className="text-[#202020CC] text-xs" />
                </Button>
              </li>

            </>
          ))}
        </ul>
      </div>

      {selectedAllergy && (
        <Modal isOpen={isAllergyModalOpen} onClose={closeAllergyModal} title={"Update Allergies"}>
          <AllergyForm allergy={selectedAllergy} onClose={closeAllergyModal} />
        </Modal>
      )}
    </div>
  );
}
